import { identity } from '@bonitour/common-functions'

export const parseDecimal = (value) => {
  let parsedValue = value

  if (isNaN(value)) {
    parsedValue = 0
  }

  return (Math.round(parsedValue * 100) / 100).toString()
}

export const sliceDecimal = (value, sliceIndex = 2) => {
  const parts = value.split('.')

  let formattedValue = parts[0]

  if (parts.length > 1) {
    formattedValue += '.' + parts[1].slice(0, sliceIndex)
  }

  return formattedValue
}

// Only work with text input
export const handleChangeTwoDecimalInput = (handleChange = identity) => (value) => {
  if (!/^\d*\.?\d*$/.test(value)) return

  const parsedValue = value?.toString()
  const containsDecimalPoint = parsedValue?.includes('.')
  const decimalPointIndex = parsedValue?.indexOf('.')

  if (containsDecimalPoint) {
    const newValue = parsedValue.slice(0, decimalPointIndex + 3)
    return handleChange(newValue)
  }

  handleChange(value)
}

export const handleBlurTwoDecimalInput = (onChange = identity, onBlur = identity) => (value) => {
  const parsedValue = value?.toString()

  const isPointLastChar = parsedValue?.[parsedValue.length - 1] === '.'

  if (isPointLastChar) {
    onChange(parsedValue?.slice(0, -1))
  }

  onBlur(value)
}
